/**
 * Card — kit surface. Ported from design/project/lib/dash.jsx:
 * surface-1 fill, line-2 hairline, rad-3 corners, 16px default padding.
 */
import type { HTMLAttributes } from "react";

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** Padding in px (the prototype's `pad` prop). 0 for flush lists. */
  pad?: number;
}

export function Card({ pad = 16, className, style, children, ...rest }: CardProps) {
  return (
    <div
      {...rest}
      className={["ns-card", className ?? ""].filter(Boolean).join(" ")}
      style={{ padding: pad, ...style }}
    >
      {children}
    </div>
  );
}
